import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../../../../Icons'

const UnlockRewardInfo = ({ onSendUpselling = () => {}, isLoading }) => {
  const { t } = useTranslation(['rewards-table'])
  return (
    <div>
      <div className="rewards-modal-content rewards-base-view unlock-reward-info">
        <span className="warning">
          <Icon
            icon="padlock"
            svgProps={{ fillRule: 'evenodd', clipRule: 'evenodd' }}
            viewBox={'0 0 60 60'}
          />
          {t('rewards-table:unlockRewardInfo.featureLocked')}
        </span>
        <h3>{t('rewards-table:unlockRewardInfo.title')}</h3>
        <p>{t('rewards-table:unlockRewardInfo.description')}</p>
        <img src="/images/unlock-reward.png" />
      </div>
      <div className="rewards-modal-actions">
        <button
          className="button button-primary"
          disabled={isLoading}
          onClick={onSendUpselling}
          style={{ width: '100%' }}
        >
          {t('rewards-table:unlockRewardInfo.talkToAccountManagerButton')}
        </button>
      </div>
    </div>
  )
}

UnlockRewardInfo.propTypes = {
  isLoading: PropTypes.bool,
  onSendUpselling: PropTypes.func,
}

export default UnlockRewardInfo
